import React from "react";
import wp1 from "../assets/terrace9.jpg";
import wp2 from "../assets/bathroom7.jpg";
import wp3 from "../assets/basement11.jpg";
import wp4 from "../assets/waterproofing4.jpg";

const categories = [
  {
    id: 1,
    title: "Terrace Waterproofing",
    subtitle: "ROOF PROTECTION",
    description:
      "Ensure your terrace remains completely leak-free throughout the year with our advanced waterproofing solutions. We use high-quality membranes, protective coatings, and modern application techniques to prevent water seepage, structural damage, and cracks. Our expert team ensures long-lasting protection that not only safeguards your property but also enhances the durability and value of your roof.",
    image: wp1,
  },
  {
    id: 2,
    title: "Bathroom Leakage",
    subtitle: "SAFE & DURABLE",
    description:
      "Advanced bathroom waterproofing using high-quality sealants, membranes, and protective coatings to prevent water seepage, mold growth, dampness, and structural damage. Our expert application ensures a completely sealed, hygienic, and long-lasting bathroom, protecting walls, floors, and fittings from moisture-related issues for years to come.",
    image: wp2,
  },
  {
    id: 3,
    title: "Basement Protection",
    subtitle: "DRY & SECURE",
    description:
      "Keep your basement completely moisture-free with our expert waterproofing and insulation services. We use advanced sealing systems and protective coatings to prevent water intrusion, dampness, mold growth, and structural deterioration, ensuring long-term protection and a dry, safe, and usable basement space for years to come.",
    image: wp3,
  },
  {
    id: 4,
    title: "Crack Treatment",
    subtitle: "REPAIR & PREVENT",
    description:
      "Advanced crack repair solutions using high-quality waterproofing materials to restore damaged surfaces and prevent future leaks, moisture intrusion, and structural deterioration, ensuring long-lasting strength, safety, and durability.",
    image: wp4,
  },
];

const CategorySection = () => {
  return (
    <section className="relative py-40 mt-8 overflow-hidden">
  <img
    src={wp1}
    className="absolute inset-0 w-full h-full object-cover scale-110"
  />

  {/* Luxury gradient overlay */}
  <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/40 to-amber-900/40"></div>

  <div className="relative z-10 max-w-6xl mx-auto grid md:grid-cols-2 gap-12">
    {categories.map((item) => (
      <div
        key={item.id}
        className="bg-white/15 backdrop-blur-2xl border border-white/20 p-10 rounded-3xl"
      >
        <h3 className="text-3xl font-serif text-white">
          {item.title}
        </h3>
        <p className="text-white/80 mt-3">
          {item.description}
        </p>
      </div>
    ))}
  </div>
</section>

  );
};
{/* Bottom fade to next section */}
<div className="
  absolute bottom-0 left-0 w-full h-40
  bg-gradient-to-t from-[#0f0f0f] to-transparent
"/>


export default CategorySection;
